import JsPDF from 'jspdf';
import moment from 'moment';
import PoomsaeAPIService from "../../../../servicehandlers/PoomsaeAPIService";
import KicksAPIService from "../../../../servicehandlers/KicksAPIService";
import SelfDefenseTechniquesAPIService from "../../../../servicehandlers/SelfDefenseTechniquesAPIService";
import KickCombosAPIService from "../../../../servicehandlers/KickCombosAPIService";
import TechniquesAPIService from "../../../../servicehandlers/TechniquesAPIService";
import BreakingTechniquesAPIService from "../../../../servicehandlers/BreakingTechniquesAPIService";
import {garamondBase64} from "../../Pages/Admin/Fonts/garamond";

const poomsaeAPIService = new PoomsaeAPIService()
const kicksAPIService = new KicksAPIService()
const selfDefenseTechniquesAPIService = new SelfDefenseTechniquesAPIService()
const kickCombosAPIService = new KickCombosAPIService()
const techniqueAPIService = new TechniquesAPIService()
const breakingTechniquesAPIService = new BreakingTechniquesAPIService();
export async function printTapes() {

  // get kicks and motions for the kick combos
  let tapes = ['Kicking', 'Kick Combos', 'Poomsae', 'Techniques', 'Self Defense', 'Breaking']
  let all_kicks = null;
  try {
    all_kicks = await kicksAPIService.getKick(this.$router)
  } catch (e) {
    this.error_txt = 'Error getting kicks: ' + e;
    this.openModal('error');
    return;
  }
  let all_kick_combos = null;
  try {
    all_kick_combos = await kickCombosAPIService.getKickCombos(this.$router)
  } catch (e) {
    this.error_txt = 'Error getting kick combos: ' + e;
    this.openModal('error');
    return;
  }
  let all_poomsae = null;
  try {
    all_poomsae = await poomsaeAPIService.getPoomsae(this.$router)
  } catch (e) {
    this.error_txt = 'Error getting poomsae: ' + e;
    this.openModal('error');
    return;
  }
  let all_techs = null;
  try {
    all_techs = await techniqueAPIService.getTechnique(this.$router)
  } catch (e) {
    this.error_txt = 'Error getting techniques: ' + e;
    this.openModal('error');
    return;
  }
  let all_self_defs = null;
  try {
    all_self_defs = await selfDefenseTechniquesAPIService.getSelfDefenseTechniques(this.$router)
  } catch (e) {
    this.error_txt = 'Error getting self defense: ' + e;
    this.openModal('error');
    return;
  }

  const date = moment().format('dddd, MMMM D, YYYY');
  const doc = new JsPDF({
    orientation: "portrait",
    format: 'letter',
  });
  function addFontToPDF(pdf) {
    pdf.addFileToVFS('garamond.ttf', garamondBase64);
    pdf.addFont('garamond.ttf', 'garamond', 'normal');
  }

  addFontToPDF(doc)
  doc.setFontSize('12');
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const halfPage = pageWidth / 2;

  let fileName = 'Tapes Curriculum.pdf'

  for (let tape of tapes){
    let index = tapes.indexOf(tape) + 1
    let minPrecent = (index / tapes.length) * 100
    let gap = 100.00 / tapes.length

    let x = 10;
    let xCenter = x + ((halfPage - x) / 2)
    let y = 10;
    let lineEnd = halfPage - 10

    doc.setFontSize('8');
    doc.setFont('Helvetica', 'normal')
    doc.text(date, x, y);
    y += 7;
    doc.setFontSize('12');
    doc.text('Beyond Sports Taekwondo Curriculum', xCenter, y, 'center');
    doc.setFont('Times-Roman', 'bold')
    y += 7;

    doc.setFontSize('12');
    doc.text(tape, xCenter, y, 'center');
    doc.setFont('garamond', 'normal')
    doc.setFontSize('8');
    y += 7;

    if (tape === 'Techniques'){
      if (this.stepSparring.pdf){
        doc.setFontSize('10')
        doc.setFont('Times-Roman', 'bold')
        doc.text('Step Sparring File: ', x, y)
        y += 4;
        doc.setFontSize('8')
        doc.setFont('garamond', 'normal')
        doc.text(this.stepSparring.name, x + 3, y)
        y += 5;
      } else {
        doc.setFontSize('8')
        this.error_txt = "Current step sparring doesn't have an assigned file"
        this.openModal('error')
      }
    }

    let left = true

    for (let id of this.selectedData){
      for (let rank of this.givenData){
        if (id === rank.id){
          switch (tape){
            case 'Kicking':
              let rank_kicks = null;
              try {
                rank_kicks = await kicksAPIService.getKickByRank(rank.id, this.$router)
                if (y > (pageHeight - 20 - (rank_kicks.length * 10))){
                  if (!left) {
                    doc.addPage()
                  }
                  left = !left
                  x = left ? 10 : halfPage + 10
                  lineEnd = left ? halfPage - 10 : pageWidth - 10
                  y = 10
                }
                doc.setFontSize('12');
                doc.setFont('Times-Roman', 'bold')
                doc.text(rank.name, x, y);
                doc.setFont('garamond', 'normal')
                doc.setFontSize('8');
                y += 1;
                doc.line(x, y, lineEnd, y);
                y += 4;
                for (let item of rank_kicks){
                  for (let kick of all_kicks){
                    if (kick.id === item.kick_id){
                      if (kick.description) {
                        doc.text(kick.description, x + 5, y);
                      }
                      y += 4;
                      break
                    }
                  }
                }
                y += 2;
              } catch (e) {
                this.error_txt = 'Error getting kicks by userRank: ' + e;
                this.openModal('error');
                return;
              }
              break
            case 'Kick Combos':
              let rank_kick_combos = null;
              try {
                rank_kick_combos = await kickCombosAPIService.getKickCombosByRank(rank.id, this.$router)
                if (y > (pageHeight - 20 - (rank_kick_combos.length * 10))){
                  if (!left) {
                    doc.addPage()
                  }
                  left = !left
                  x = left ? 10 : halfPage + 10
                  lineEnd = left ? halfPage - 10 : pageWidth - 10
                  y = 10
                }
                doc.setFontSize('12');
                doc.setFont('Times-Roman', 'bold')
                doc.text(rank.name, x, y);
                doc.setFont('garamond', 'normal')
                doc.setFontSize('8');
                y += 1;
                doc.line(x, y, lineEnd, y);
                y += 4;
                for (let item of rank_kick_combos){
                  for (let kick_combo of all_kick_combos){
                    if (kick_combo.id === item.kick_combo_id){
                      if (kick_combo.description) {
                        doc.text(kick_combo.description, x + 5, y);
                      }
                      y += 4;
                      break
                    }
                  }
                }
                y += 2;
              } catch (e) {
                this.error_txt = 'Error getting kick combos: ' + e;
                this.openModal('error');
                return;
              }

              break
            case 'Poomsae':

              let poomsae_by_rank = null;
              try {
                poomsae_by_rank = await poomsaeAPIService.getPoomsaeByRank(rank.id, this.$router);
                if (y > (pageHeight - 20 - (poomsae_by_rank.length * 10))){
                  if (!left) {
                    doc.addPage()
                  }
                  left = !left
                  x = left ? 10 : halfPage + 10
                  lineEnd = left ? halfPage - 10 : pageWidth - 10
                  y = 10
                }
                doc.setFontSize('12');
                doc.setFont('Times-Roman', 'bold')
                doc.text(rank.name, x, y);
                doc.setFont('garamond', 'normal')
                doc.setFontSize('8');
                y += 1;
                doc.line(x, y, lineEnd, y);
                y += 4;
                for (let item of poomsae_by_rank){
                  for (let poomsae of all_poomsae){
                    if (poomsae.id === item.poomsae_id){
                      let printName = ''
                      if (poomsae.poom_dan.name !== 'Both'){
                        printName = poomsae.poom_dan.name + ' - '
                      }
                      printName +=  poomsae.description
                      if (poomsae_by_rank.indexOf(item) === poomsae_by_rank.length - 1 || rank.order === 1) {
                        printName = 'Current: ' + printName
                      } else {
                        printName = 'Previous: ' + printName
                      }

                      if (doc.getTextWidth(printName) >= 70 && poomsae.description) {
                        let splitStr = printName.split(' ')
                        let builtStr = ''
                        let textWidth
                        while (splitStr.length !== 0) {
                          textWidth = doc.getTextWidth(builtStr + splitStr[0] + ' ')
                          if (textWidth > 70) {
                            doc.text(builtStr, x + 5, y)
                            y += 3
                            builtStr = splitStr.shift() + ' '
                          } else {
                            builtStr += splitStr.shift() + ' '
                          }
                        }
                        doc.text(builtStr, x + 5, y)
                      } else {
                        doc.text(`${printName}`, x + 5, y)
                      }
                      y += 5
                      break
                    }
                  }
                }
                y += 2;
              } catch (e) {
                this.error_txt = 'Unresolved data error getting poomsae to ranks: ' + e;
                this.openModal('error');
              }
              break
            case 'Techniques':
              let techniques_by_rank = null;
              try {
                techniques_by_rank = await techniqueAPIService.getTechniqueByRank(rank.id, this.$router);
                if (y > (pageHeight - 20 - (techniques_by_rank.length * 10))){
                  if (!left) {
                    doc.addPage()
                  }
                  left = !left
                  x = left ? 10 : halfPage + 10
                  lineEnd = left ? halfPage - 10 : pageWidth - 10
                  y = 10
                }
                doc.setFontSize('12');
                doc.setFont('Times-Roman', 'bold')
                doc.text(rank.name, x, y);
                doc.setFont('garamond', 'normal')
                doc.setFontSize('8');
                y += 1;
                doc.line(x, y, lineEnd, y);
                y += 4;
                for (let item of techniques_by_rank){
                  for (let tech of all_techs){
                    if (tech.id === item.technique_id){
                      if (tech.description) {
                        doc.text(tech.description, x + 5, y);
                      }
                      y += 4;
                      break
                    }
                  }
                }
                y += 2;
              } catch (e) {
                this.error_txt = 'Unresolved data error getting techniques to ranks: ' + e;
                this.openModal('error');
              }
              break
            case 'Self Defense':
              let self_defense_by_rank = null;
              try {
                self_defense_by_rank = await selfDefenseTechniquesAPIService.getSelfDefenseTechniquesByRank(rank.id, this.$router);
                if (y > (pageHeight - 20 - (self_defense_by_rank.length * 10))){
                  if (!left) {
                    doc.addPage()
                  }
                  left = !left
                  x = left ? 10 : halfPage + 10
                  lineEnd = left ? halfPage - 10 : pageWidth - 10
                  y = 10
                }
                doc.setFontSize('12');
                doc.setFont('Times-Roman', 'bold')
                doc.text(rank.name, x, y);
                doc.setFont('garamond', 'normal')
                doc.setFontSize('8');
                y += 1;
                doc.line(x, y, lineEnd, y);
                y += 4;
                for (let item of self_defense_by_rank){
                  for (let self_def of all_self_defs){
                    if (self_def.id === item.self_defense_techniques_id){
                      if (self_def.description) {
                        doc.text(self_def.description, x + 5, y);
                      }
                      y += 4;
                      break
                    }
                  }
                }
                y += 2;
              } catch (e) {
                this.error_txt = 'Unresolved data error getting self defense techniques to ranks: ' + e;
                this.openModal('error');
              }
              break
            case 'Breaking':
              let breaking_by_rank = null;
              try {
                breaking_by_rank = await breakingTechniquesAPIService.getBreakingTechniquesByRankID(rank.id, this.$router);
                if (y > (pageHeight - 20 - (breaking_by_rank.length * 10))){
                  if (!left) {
                    doc.addPage()
                  }
                  left = !left
                  x = left ? 10 : halfPage + 10
                  lineEnd = left ? halfPage - 10 : pageWidth - 10
                  y = 10
                }
                doc.setFontSize('12');
                doc.setFont('Times-Roman', 'bold')
                doc.text(rank.name, x, y);
                doc.setFont('garamond', 'normal')
                doc.setFontSize('8');
                y += 1;
                doc.line(x, y, lineEnd, y);
                y += 4;
                const techniques = breaking_by_rank.breaking_techniques;
                for (const technique of techniques) {
                  if (technique.description) {
                    doc.text(technique.description, x + 5, y);
                  }
                  y += 4;
                }
              } catch (e) {
                this.error_txt = 'Unresolved data error getting self techniques to ranks: ' + e;
                this.openModal('error');
              }
              break
          }
        }
      }
      index = this.selectedData.indexOf(id) + 1
      let currentPercent = (index / this.selectedData.length)
      currentPercent = minPrecent + (currentPercent * gap)
      this.precentage = parseFloat((Math.round(currentPercent * 100) / 100).toFixed(1))
      if (this.precentage > 100){
        this.precentage = 100
      }
    }

    if (tapes.indexOf(tape) !== tapes.length - 1){
      doc.addPage()
    }
  }
  doc.save(fileName);
}
